import axios from 'axios'
import React, { use, useEffect } from 'react'

const DriverLocation = () => {

    const fetch = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/outstation/driverLocation`,
                {
                    withCredentials: true
                })

            console.log("Driver location data:", response.data);
        } catch (error) {
            console.log("Error fetching driver location data:", error);
        }

    }

    useEffect(() => {
        fetch();
    }, [])
    return (
        <div>
            <h2>
                Driver Location
            </h2>
        </div>
    )
}

export default DriverLocation